var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.className,attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10 17V8","stroke":"#202830","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"10","cy":"3","r":"1","fill":"#202830"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }